import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MostSearchedFlightsResponse, SearchCriteria } from './interfaces';
import { Router } from '@angular/router';
import { retry, take, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class MostSearchedFlightsService {
  public isLoading = false;
  public isError = false;
  public isEmpty = false;

  private _mostSearchedFlights: MostSearchedFlightsResponse[] = [];
  private _mostSearchedFlightsChunks: MostSearchedFlightsResponse[][] = [];
  private http = inject(HttpClient);
  private router = inject(Router);

  getMostSearchedFlights() {
    this.isLoading = true;

    const mostSearchedFlights = sessionStorage.getItem('mostSearchedFlights');

    if (mostSearchedFlights) {
      this._mostSearchedFlights = JSON.parse(mostSearchedFlights);
      this.chunkArray();

      this.isLoading = false;
      this.isEmpty = !this._mostSearchedFlights.length;

      return;
    }

    this.http
      .get<MostSearchedFlightsResponse[]>('https://flightsearch.travasky.com/api/GetCheapestFlights?resCount=5')
      .pipe(
        retry(3),
        take(1),
        catchError((err) => {
          console.error(err);
          throw err;
        }),
      )
      .subscribe({
        next: (res) => {
          sessionStorage.setItem('mostSearchedFlights', JSON.stringify(res));

          this._mostSearchedFlights = res;
          this.chunkArray();
          this.isEmpty = !res.length;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
          this.isError = true;
        },
      });
  }

  goToSearchResults(searchCriteria: SearchCriteria) {
    localStorage.removeItem('form');

    let flights: string[] = [];

    searchCriteria.flights.forEach(e => {
      const departingOnDate = new Date(e.departingOnDate);

      const formattedDate = departingOnDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "2-digit"
      });

      flights.push(e.departingFrom + '-' + e.arrivingTo + '-' + formattedDate);
    })
    
    this.router.navigate([
      'flightResult',
      searchCriteria.language,
      searchCriteria.currency,
      searchCriteria.pos,
      searchCriteria.flightType,
      flights.join('_'),
      searchCriteria.searchId,
      'A-' + searchCriteria.adultNum + '-C-' + searchCriteria.childNum + '-I-' + searchCriteria.infantNum,
      searchCriteria.selectedFlightClass,
      searchCriteria.selectDirectFlightsOnly
    ])
  }

  chunkArray(chunkSize = 3): void {
    const result: MostSearchedFlightsResponse[][] = [];
    for (let i = 0; i < this._mostSearchedFlights.length; i += chunkSize) {
      result.push(this._mostSearchedFlights.slice(i, i + chunkSize));
    }

    this._mostSearchedFlightsChunks = result;
  }

  get mostSearchedFlights() {
    return this._mostSearchedFlights;
  }

  get mostSearchedFlightsChunks() {
    return this._mostSearchedFlightsChunks;
  }
}
